module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("OA2p6"))).then(() => parcelRequire('hEqeo'));